var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71985 10.2108H7.43426V9.05484H2.71985V10.2108ZM2.71985 7.12828H9.61015V5.97234H2.71985V7.12828ZM2.71985 4.04578H9.61015V2.88984H2.71985V4.04578ZM1.31115 13.1006C0.944756 13.1006 0.634632 12.9658 0.380779 12.696C0.126926 12.4263 0 12.0968 0 11.7075V1.3931C0 1.0038 0.126926 0.674297 0.380779 0.404578C0.634632 0.134859 0.944756 0 1.31115 0H11.0188C11.3852 0 11.6954 0.134859 11.9492 0.404578C12.2031 0.674297 12.33 1.0038 12.33 1.3931V11.7075C12.33 12.0968 12.2031 12.4263 11.9492 12.696C11.6954 12.9658 11.3852 13.1006 11.0188 13.1006H1.31115ZM1.31115 11.9447H11.0188C11.0747 11.9447 11.1258 11.92 11.1722 11.8705C11.2188 11.8212 11.2421 11.7669 11.2421 11.7075V1.3931C11.2421 1.33376 11.2188 1.27943 11.1722 1.23011C11.1258 1.18066 11.0747 1.15594 11.0188 1.15594H1.31115C1.2553 1.15594 1.20417 1.18066 1.15775 1.23011C1.11121 1.27943 1.08794 1.33376 1.08794 1.3931V11.7075C1.08794 11.7669 1.11121 11.8212 1.15775 11.8705C1.20417 11.92 1.2553 11.9447 1.31115 11.9447Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/Hours.a51386ed9c2794bbd8fa35100025e9d8.svg";
export { ForwardRef as ReactComponent };